import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL, errMsg, todayPL } from './shared';

export const WorkerDialog = ({ open, onClose, worker, onSaved }) => {
  const editing = !!worker;
  const [f, setF] = useState(() => ({
    imie: worker?.imie || '', nazwisko: worker?.nazwisko || '', telefon: worker?.telefon || '', stawka: '', od: todayPL(),
  }));
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try {
      if (editing) {
        await axios.patch(`${API_URL}/godziny/workers/${worker.id}`, { imie: f.imie, nazwisko: f.nazwisko, telefon: f.telefon });
        if (f.stawka !== '') await axios.post(`${API_URL}/godziny/workers/${worker.id}/rates`, { stawka: Number(f.stawka), od: f.od });
      } else {
        await axios.post(`${API_URL}/godziny/workers`, { ...f, stawka: Number(f.stawka) });
      }
      toast.success('Zapisano pracownika');
      onSaved();
      onClose();
    } catch (e) { toast.error(errMsg(e, 'Błąd zapisu')); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)]" data-testid="worker-dialog">
        <DialogHeader><DialogTitle className="text-[var(--crm-text-primary)]">{editing ? 'Edytuj pracownika' : 'Nowy pracownik'}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Imię</Label><Input value={f.imie} onChange={set('imie')} data-testid="worker-imie-input" /></div>
          <div><Label>Nazwisko</Label><Input value={f.nazwisko} onChange={set('nazwisko')} data-testid="worker-nazwisko-input" /></div>
          <div className="col-span-2"><Label>Telefon</Label><Input value={f.telefon} onChange={set('telefon')} data-testid="worker-telefon-input" /></div>
          <div>
            <Label>{editing ? 'Nowa stawka (zł/h) – opcjonalnie' : 'Stawka (zł/h)'}</Label>
            <Input type="number" min="0" step="0.5" value={f.stawka} onChange={set('stawka')} data-testid="worker-stawka-input"
              placeholder={editing ? `obecnie ${worker.stawka} zł/h` : ''} />
          </div>
          <div><Label>Obowiązuje od</Label><Input type="date" value={f.od} onChange={set('od')} data-testid="worker-od-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anuluj</Button>
          <Button onClick={save} disabled={saving || !f.imie || (!editing && f.stawka === '')} className="bg-[#FF6B35] hover:bg-[#e55a2b] text-white"
            data-testid="worker-save-btn">{saving ? 'Zapisywanie...' : 'Zapisz'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
